import { render } from "./UnreadAlert.vue?vue&type=template&id=2f146bb1&scoped=true"
import script from "./UnreadAlert.vue?vue&type=script&lang=js"
export * from "./UnreadAlert.vue?vue&type=script&lang=js"

import "./UnreadAlert.vue?vue&type=style&index=0&id=2f146bb1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f146bb1"]])

export default __exports__